import Vue from "vue";
import Router from "vue-router";
import SurveyList from "@/components/SurveyView/SurveyList";
import FreeOffers from "@/components/FreeOffers/FreeOffers";
import PageNotFound from "@/components/PageNotFound";
import Settlement from "@/components/Settlement/SettlementList";
import AppRegistration from "../components/AppRegistration/AppRegistration";

Vue.use(Router);

let routes = [
  // Routes to the different components are registered here
  {
    path: "/surveyview",
    name: "SurveyView",
    component: SurveyList,
  },
  {
    path: "/settlement",
    name: "Settlement",
    component: Settlement,
  },
  {
    path: "/freeoffers",
    name: "FreeOffers",
    component: FreeOffers,
  },
  {
    path: "/appregistration",
    name: "AppRegistration",
    component: AppRegistration,
  },
  {
    path: "/surveycode",
    name: "SurveyCodeLogin",
  },
  {
    path: "/surveycode/:sc",
    name: "SurveyCodeDirectLogin",
  },
  {
    path: "/callback",
    name: "DirectToLoginCallback",
  },
  {
    path: "/logout_callback",
    name: "DirectToLogoutCallback",
  },
  {
    path: "/app-access/:code",
    name: "AppAccess",
  },
];

routes.push({
  path: "*",
  component: PageNotFound,
});

export default new Router({
  //mode: 'history',
  routes: routes,
});



// WEBPACK FOOTER //
// ./src/router/index.js